<div class="minimal-modal-wrapper p-4 text-center">
    <button type="button" class="btn-close-minimal" (click)="activeModal.dismiss()">
        <span class="material-symbols-outlined">close</span>
    </button>

    <div class="icon-container mb-3">
        <div class="icon-shape primary-shape">
            <span class="material-symbols-outlined">add_link</span>
        </div>
    </div>

    <h3 class="modal-title-clean">Nuova Scansione Web</h3>
    <p class="modal-text mb-4">
        Stai per aggiungere un nuovo sito all'indice: <br>
        <strong class="text-primary">{{ indexName }}</strong>
    </p>

    <div class="input-area text-start mb-4">
        <label class="form-label fw-bold mb-2">URL del sito</label>
        <input type="url" 
               class="form-control custom-input" 
               [(ngModel)]="urlToCrawl" 
               placeholder="https://esempio.com"
               (keyup.enter)="confirm()">
    </div>

    <div class="modal-actions d-flex justify-content-center gap-3">
        <button type="button" class="btn-action btn-cancel" (click)="activeModal.dismiss()">
            Annulla
        </button>
        <button type="button" 
                class="btn-action btn-confirm" 
                [disabled]="!urlToCrawl" 
                (click)="confirm()">
            Avvia Scansione
        </button>
    </div>
</div>